// CartEmpty.jsx
import React from 'react';

const CartEmpty = () => {
    return (
        <div className="cart-empty">
            <img src="/images/empty_cart.png" alt="empty cart" className="empty-image" />
            <p className="empty-text">장바구니에 담긴 상품이 없습니다.</p>
        </div>
    );
};

export default CartEmpty;
